import React, { useContext, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { BuildingFill, FolderFill, FileEarmarkTextFill, Folder } from 'react-bootstrap-icons'
import { useNavigate } from 'react-router-dom'
import { BrowseContext } from '../../../../contexts/BrowseContext'

export default observer(function CreateOptions({ isOpen, onClose }) {
  const { browseState } = useContext(BrowseContext)
  const [hoverClient, setHoverClient] = useState(false)
  const [hoverFolder, setHoverFolder] = useState(false)
  const [hoverCampaign, setHoverCampaign] = useState(false)

  const navigate = useNavigate()

  return (
    isOpen && (
      <section className='flex flex-col gap-1 shadow z-30 absolute bg-white dark:bg-rb-dark-mode-lighter w-[198px] mt-2 border-1 dark:border-rb-dark-mode rounded-md'>
        <button
          className={`w-full ${hoverClient ? 'bg-rb-grey dark:bg-rb-dark-mode': ''} flex items-center gap-2 p-2 dark:text-white`}
          onMouseEnter={() => setHoverClient(true)}
          onMouseLeave={() => setHoverClient(false)}
          onClick={() => {
            browseState.toggleCreateClient()
            onClose()
          }}
        >
          <BuildingFill className="rb-text-muted" style={{ color: hoverClient ? '#2563EB' : undefined }} />
          <span className="dark:text-white">Client</span>
        </button>
        <button
          className={`w-full ${hoverFolder ? 'bg-rb-grey dark:bg-rb-dark-mode': ''} flex items-center gap-2 p-2 dark:text-white`}
          onMouseEnter={() => setHoverFolder(true)}
          onMouseLeave={() => setHoverFolder(false)}
          onClick={() => {
            browseState.toggleCreateFolder()
            onClose()
          }}
        >
          <FolderFill className="rb-text-muted" style={{ color: hoverFolder ? '#EAB308' : undefined }} />
          <span className="dark:text-white">Folder</span>
        </button>
        <button
          className={`w-full ${hoverCampaign ? 'bg-rb-grey dark:bg-rb-dark-mode' : ''} flex items-center gap-2 p-2 dark:text-white`}
          onMouseEnter={() => setHoverCampaign(true)}
          onMouseLeave={() => setHoverCampaign(false)}
          onClick={() => navigate('/project_manager/campaigns/new')}
        >
          <FileEarmarkTextFill className="rb-text-muted" style={{ color: hoverCampaign ? '#2CCDB4' : undefined }}/>
          <span className="dark:text-white">Campaign</span>
        </button>
      </section>
    )
  )
})
